import {
	SYS_SPACE_FIXED_150,
	SYS_SPACE_FIXED_200,
	SYS_SPACE_FIXED_300,
	SYS_SPACE_FIXED_400,
	SYS_SPACE_FIXED_450,
	SYS_SPACE_RELATIVE_2_XL,
} from '@oneaudi/unified-web-alpha-common';

import styled from 'styled-components';
import { ConfigurationStepStyle } from '~/app/compositions/sidebar/trim-line/styles/selection-step-section-style';
import { mobileBreakPoint } from '~/styles/break-points';

export const AccessoriesConfigurationStepStyle = styled(ConfigurationStepStyle)`
	padding-bottom: 0;
	padding-top: 0;

	.selection-step {
		display: flex;
		flex-direction: column;
		gap: ${SYS_SPACE_FIXED_300};
		padding-bottom: 1px;

		#accessories {
			margin-bottom: 0;
		}

		.button-tabs-container {
			margin: 0;
			padding: 0;
		}

		@media (min-width: ${mobileBreakPoint}px) {
			position: sticky;
			top: 0;
			padding-bottom: 72px;
			padding-top: 36px;
		}
	}
`;

export const AccessoriesSelectionStepStyle = styled.section<{ shouldShowListDesign?: boolean }>`
	display: flex;
	flex-direction: column;
	max-width: 100vw;
	width: 100%;
	gap: ${SYS_SPACE_RELATIVE_2_XL};
	padding-top: 16px;

	@media (min-width: ${mobileBreakPoint}px) {
		flex-direction: row-reverse;
	}

	.equipment-container {
		display: flex;
		flex-direction: column;
		${({ shouldShowListDesign }) =>
			!shouldShowListDesign &&
			`
				display: grid;
				grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
				grid-auto-rows: min-content;
				gap: ${SYS_SPACE_FIXED_200};
			`}
		gap: ${SYS_SPACE_FIXED_200};
		height: fit-content;
		width: 100%;

		.pagination-items {
			margin-top: ${SYS_SPACE_FIXED_450};
			grid-column: 1 / -1;
			display: flex;
			flex-direction: column;
			gap: ${SYS_SPACE_FIXED_150};
			place-items: center;

			.pagination-button {
				width: 100%;

				@media (min-width: ${mobileBreakPoint}px) {
					width: auto;
				}
			}
		}
	}
`;

export const NoResultContainer = styled.div`
	padding: 1.5rem;
	width: 100%;
	grid-column: 1 / -1;
	white-space: pre-line;
	h4 {
		margin-bottom: ${SYS_SPACE_FIXED_150};
	}
	button {
		margin-top: ${SYS_SPACE_FIXED_400};
	}
`;

export const StyledAccessoriesWrapper = styled.ul`
	display: flex;
	flex-direction: column;
	gap: ${SYS_SPACE_FIXED_200};
`;
